// extracted by mini-css-extract-plugin
export default {"grid":"V8Bkbz","empty":"liimYk"};